/**
 * SDK对tsgis的命名适配
 */
define([], function() {
    if (!window.g2) {
        window.g2 = window.egis;
    }
    return window.g2;
});